import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/Services/auth.service';
import { AllPlatformCurrencyExchangeRate } from 'src/app/Services/Wix-Service/wix.service';
import { ServiceBase } from 'src/app/Services/service.base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CurrencyExchangeService extends ServiceBase {

  private api = '/CurrencyExchange';
  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

 public fetchAllPlatformCurrencyWithExchangeRate(
  platforms: { plateform: string; accountId: string }[]
): Observable<AllPlatformCurrencyExchangeRate> {
  const httpOptions = this.RequestHeaders();
  const method: string = '/fetch-all-plateform-currency-with-exchangeRate';
  const url: string = environment.BASE_API_PATH + this.api + method;

  return this.http.post<AllPlatformCurrencyExchangeRate>(url, platforms, httpOptions);
}

  
}



